export default __webpack_public_path__ + "static/media/12AW1DEC65.781af2a3.jpg";